<template>
    <v-container grid-list-lg style="max-width: 1240px" class="py-0 px-0">
        <v-layout>
            <v-flex pb-2 pt-0>
                <h2>Транспортное средство
                    <v-progress-circular
                        v-if="numberInfoLoading"
                        class="ml-1"
                        indeterminate
                        color="#00ba57"
                        size="10"
                        width="2"
                    />
                </h2>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex
                v-if="!short"
                xs12 sm12 md4 lg2 py-0
                style="align-self: flex-end"
            >
                <v-checkbox
                    class="checkbox-plate"
                    style="margin-top: 0; height: 25px;"
                    label="Без номера"
                    v-model="value.noLicensePlate"
                    @change="value.licensePlate = value.noLicensePlate ? null : value.licensePlate"
                    :disabled="loadingLicensePlateInfo || value.carDoc.type === 'srts'"
                />
                <div v-if="showLicensePlateInfoLoader" class="pt-1">
                    <a :class="(value.noLicensePlate || !value.licensePlate || loadingLicensePlateInfo) ? 'policy-disabled' : 'policy'"
                       style="text-decoration: underline"
                       @click="loadInfoByLicensePlate"
                    >
                        Получить данные ТС
                    </a>
                    <v-progress-circular
                        v-if="loadingLicensePlateInfo"
                        class="ml-1"
                        indeterminate
                        color="#00ba57"
                        size="10"
                        width="2"
                    />
                </div>
                <v-text-field
                    v-if="!value.noLicensePlate"
                    v-model="value.licensePlate"
                    :rules="[rules.required, rules.russianOnly, rules.numberRule]"
                    label="Гос номер"
                    validate-on-blur
                    required
                    mask='SSSSSSSSS'
                    @input="value.licensePlate = value.licensePlate.toUpperCase()"
                    :placeholder="(value.category === 'A' || value.category === 'T') ? '1234AA161' : 'А123AA161'"
                    :disabled="loadingLicensePlateInfo"
                />
                <v-text-field
                    v-if="value.noLicensePlate"
                    label="Гос номер"
                    :disabled="true"
                />
            </v-flex>

            <v-flex
                v-if="(!short || showMark) && (value.noLicensePlate || TSLoaded || !b2b)"
                xs12 sm6 md4 lg3 py-0
                style="align-self: flex-end;"
            >
                <a v-if="showLicensePlateInfoLoader && isDefaultValue"
                   class="policy ml-2"
                   style="text-decoration: underline"
                   @click="$emit('clearTransport')"
                >
                    Удалить данные ТС
                </a>
                <v-text-field
                    v-if="!b2b"
                    v-model="value.mark"
                    :items="transportMarks"
                    :rules="[rules.required]"
                    :search-input="markSearchSync"
                    @update:searchInput="markSearch"
                    label="Марка"
                    placeholder="Введите марку по буквам"
                    no-data-text=""
                    auto-select-first
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                />

                <v-autocomplete
                    v-if="b2b"
                    v-model="value.mark"
                    :items="transportMarks"
                    :rules="[rules.required]"
                    :search-input="markSearchSync"
                    @update:searchInput="markSearch"
                    label="Марка"
                    placeholder="Введите марку по буквам"
                    no-data-text="Марка ТС не найдена"
                    auto-select-first
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                />
            </v-flex>
            <v-flex
                v-if="(!short || showMark) && (value.noLicensePlate || TSLoaded || !b2b)"
                xs12 md4 lg3 py-0
                style="align-self: flex-end;"
            >
                <v-text-field
                    v-if="!b2b"
                    v-model="value.model"
                    :items="transportModels"
                    :rules="[rules.required]"
                    label="Модель"
                    placeholder="Введите модель по буквам"
                    :search-input="modelSearchSync"
                    @update:searchInput="modelSearch"
                    no-data-text=""
                    :disabled="!this.value.mark || loadingLicensePlateInfo || numberInfoLoading"
                    validate-on-blur
                    required
                />

                <v-autocomplete
                    v-if="b2b"
                    v-model="value.model"
                    :items="transportModels"
                    :rules="[rules.required]"
                    label="Модель"
                    placeholder="Введите модель по буквам"
                    :search-input="modelSearchSync"
                    @update:searchInput="modelSearch"
                    no-data-text="Модель ТС не найдена"
                    :disabled="!this.value.mark || loadingLicensePlateInfo || numberInfoLoading"
                    validate-on-blur
                    required
                />
            </v-flex>

            <v-flex v-if="modelCategories.length > 1"
                    xs12 sm6 md4 lg3 py-0
                    style="align-self: flex-end;"
            >
                <v-select
                    v-model="value.category"
                    :items="modelCategories"
                    label="Категория ТС"
                    no-data-text="Для данной модели нет категорий"
                    @change="loadModifications(value.mark, value.model, value.category)"
                />
            </v-flex>

            <v-flex
                v-if="!short && (value.noLicensePlate || TSLoaded || !b2b)"
                xs12 sm12 md6 lg4 py-0
                style="align-self: flex-end;"
            >
                <v-radio-group
                    row
                    v-model="value.idType"
                    style="margin-bottom: -25px"
                    @change="nullNumberValues"
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                >
                    <v-radio
                        label="VIN"
                        value="vin"
                    />
                    <v-radio
                        label="№ Кузова"
                        value="bodyNumber"
                    />
                    <v-radio
                        label="№ Шасси"
                        value="chassisNumber"
                    />
                </v-radio-group>

                <v-text-field
                    pt-0
                    v-if="value.idType==='vin' && vinHide"
                    v-model="value.vinHidden"
                    :rules="[rules.required, rules.vin]"
                    v-mask="'VVVVVVVVVVVVVVVVV'"
                    label="VIN (Идентификационный номер)"
                    @input="vinOtoZeroAndUpperCase(value.vinHidden)"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                    class="to-upper-case"
                />
                <v-text-field
                    pt-0
                    v-if="value.idType==='vin'"
                    v-model="value.vin"
                    :rules="[rules.required, rules.vin]"
                    v-mask="'VVVVVVVVVVVVVVVVV'"
                    label="VIN (Идентификационный номер)"
                    @input="vinOtoZeroAndUpperCase(value.vin)"
                    @blur="onVinNumberBlur"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                    :class="[vinHide ? 'hide-vin-field' : 'to-upper-case']"
                />
                <v-text-field
                    pt-0
                    v-if="value.idType==='bodyNumber'"
                    v-model="value.bodyNumber"
                    :rules="[rules.required, rules.bodyNumber]"
                    v-mask="'NNNNNNNNNNNNNNNNN'"
                    @input="value.bodyNumber = stringToUpper(value.bodyNumber)"
                    label="№ Кузова"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                />
                <v-text-field
                    pt-0
                    v-if="value.idType==='chassisNumber'"
                    v-model="value.chassisNumber"
                    :rules="[rules.required, rules.chassisNumber]"
                    v-mask="'NNNNNNNNNNNNNNNNN'"
                    @input="value.chassisNumber = stringToUpper(value.chassisNumber)"
                    label="№ Шасси"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                />
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex
                v-if="showWrittenMake || showWrittenModel"
                xs12 sm12 md4 lg2 py-0
                class="flex-end"
            >
            </v-flex>
            <v-flex
                v-if="showWrittenMake"
                xs12 sm6 md4 lg3 py-0
            >
                <v-text-field
                    pt-0
                    v-model="value.writtenMark"
                    :rules="[rules.required]"
                    label="Марка по ПТС"
                    validate-on-blur
                    required
                    :disable="numberInfoLoading"
                />
            </v-flex>
            <v-flex
                v-if="!showWrittenMake && showWrittenModel"
                xs12 sm6 md4 lg3 py-0
                class="flex-end"
            >
            </v-flex>

            <v-flex
                v-if="showWrittenModel"
                xs12 sm6 md4 lg3 py-0
            >
                <v-text-field
                    pt-0
                    v-model="value.writtenModel"
                    :rules="[rules.required]"
                    label="Модель по ПТС"
                    validate-on-blur
                    required
                    :disable="numberInfoLoading"
                />
            </v-flex>
            <v-flex
                v-if="showWrittenMake || showWrittenModel"
                xs12 sm6 md4 lg3 py-0
                class="pts-help-text"
            >
                <p>Эти поля работают только<br>для СК 21 Век</p>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex
                v-if="!short && (value.noLicensePlate || TSLoaded || !b2b)"
                xs12 sm6 md6 lg3 pt-3 pb-0
                style="align-self: flex-end"
            >
                <v-text-field
                    type="number"
                    v-model.number="value.yearIssue"
                    label="Год выпуска"
                    :rules="[rules.required, rules.yearIssue]"
                    mask="####"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                />
            </v-flex>

            <v-flex
                xs12 sm6 md6 py-0
                :class="[this.short ? 'lg5' : 'lg3']"
                style="align-self: flex-end"
                v-if='(value.noLicensePlate || TSLoaded || !b2b)'
            >
                <v-text-field
                    v-if="value.category !== 'D'"
                    v-model.number="hpInput"
                    :rules="[rules.required, rules.hp]"
                    type="number"
                    step="0.1"
                    label="Мощность двигателя (л. с.)"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                    @blur="syncFromHp"
                    @keypress="onlyNumberAndDot($event)"
                    @input="replaceComma(hpInput)"
                />
                <v-text-field
                    v-if="value.category === 'D'"
                    v-model.number="value.seats"
                    :rules="[rules.required, rules.seats]"
                    mask="###"
                    label="Количество пассажирских мест"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo"
                />
            </v-flex>

            <v-flex
                xs12 sm6 md6 py-0
                :class="[this.short ? 'lg5' : 'lg3']"
                style="align-self: flex-end"
                v-if='(value.noLicensePlate || TSLoaded || !b2b)'
            >
                <v-text-field
                    v-if="value.category !== 'D'"
                    v-model="kwInput"
                    :rules="[rules.required, rules.kw]"
                    type="number"
                    step="0.1"
                    label="Мощность, кВт"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                    @blur="syncFromKw"
                    @keypress="onlyNumberAndDot($event)"
                    @input="replaceComma(kwInput)"
                />
            </v-flex>

            <v-flex
                xs12 sm6 md6 py-0
                :class="[this.short ? 'lg5' : 'lg3']"
                style="align-self: flex-end"
                v-if="value.category === 'C' && (value.noLicensePlate || TSLoaded || !b2b)"
            >
                <v-text-field
                    v-if="value.category === 'C'"
                    v-model.number="value.maxMass"
                    :rules="[rules.required, rules.maxMass]"
                    mask="#####"
                    label="Максимальная разрешенная масса (кг.)"
                    validate-on-blur
                    required
                    :disabled="loadingLicensePlateInfo || numberInfoLoading"
                />
            </v-flex>

            <v-flex
                v-if="false"
                xs12 sm12 md6 pt-3 pb-0
                style="align-self: flex-end"
            >
                <v-select
                    class="modification-select"
                    v-model="value.carCode"
                    :items="allowedModifications"
                    item-text="name"
                    item-value="code"
                    label="Модификация"
                    clearable
                    @change="modificationChanged"
                    no-data-text="Не найдено"
                />
            </v-flex>

            <v-flex
                v-if="!short && (value.noLicensePlate || TSLoaded || !b2b)"
                xs12 sm6 md3 pb-3
                style="align-self: flex-end"
            >
                <span style="font-size: 12px">Категория</span>
                <p>{{ this.categories[value.category] }}</p>
            </v-flex>

            <v-flex
                v-if="!short && (value.category === 'B' || value.category === 'C' || value.category === 'T') && (value.noLicensePlate || TSLoaded || !b2b)"
                xs12 sm6 md3
                style="align-self: flex-end"
            >
                <v-checkbox
                    style="margin-top: 0;"
                    label="Используется с прицепом"
                    v-model="value.withTrailer"
                />
            </v-flex>
        </v-layout>

        <osago-cardoc
            v-if="!short && (value.noLicensePlate || TSLoaded || !b2b) && !hideCarDocAndToDoc"
            v-model="value.carDoc"
            :yearIssue="value.yearIssue"
            :dateToday="dateToday"
            :showCarDocLoader="loadingLicensePlateInfo || loadingGibddData"
            :disabled="loadingLicensePlateInfo || loadingGibddData"
            :numberInfoLoading="numberInfoLoading"
            :gibddInfoLoading="gibddInfoLoading"
            :carProdYear="value.yearIssue"
            :category="value.category"
        />
    </v-container>
</template>

<script>
import _ from "lodash";

export default {
    name: 'Transport',
    props: [
        'value',
        'short',
        'dateToday',
        'prevPolicyNumber',
        'dateStart',
        'showLicensePlateInfoLoader',
        'defaultValue',
        'isEgarant',
        'numberInfoLoading',
        'rsaInfoLoading',
        'gibddInfoLoading',
        'dateOldPolis',
        'hideCarDocAndToDoc',
        'b2b',
        'useType',
        'vinHide',
        'isDraft',
    ],

    data: function () {
        return {
            markSearchSync: '',
            modelSearchSync: '',

            transportMarks: [],
            transportModels: [],
            modifications: [],

            showMark: false,

            TSLoaded: true, // игнорируем запрос данных по номеру ТС

            modelCategories: [],
            categories: {
                A: 'Мотоцикл (Категория A)',
                B: 'Легковое (Категория B)',
                C: 'Грузовое (Категория C)',
                D: 'Автобус (Категория D)',
                T: 'Трактор (Категория T)'
            },

            loadingLicensePlateInfo: false,
            loadingGibddData: false,

            alertText: null,
            alertColor: null,

            // проверка на доступную мощность
            // если здесь true, то после получения модификаций автомобиля,
            // нужно проверить, есть ли мощность в списке доступных, после чего сбросить флаг
            checkAvtokodAllowed: false,
            checkAvtokodAllowedPower: null,

            numberInfoRequested: false,
            prevVinValue: null,
            vinBlurTimer: 0,

            hasRequestByPlate: false,

            rules: {
                required: v => !!v || 'Обязательное поле',
                russianOnly: v => !(/[^А-Я0-9]/.test(v)) || 'Допускаются только русские буквы',
                power: v => /^\d{1,4}$/.test(v) || 'Неверный формат',
                maxMass: v => /^\d{4,5}$/.test(v) || 'Неверный формат',
                seats: v => /^\d{1,3}$/.test(v) || 'Неверный формат',
                vin: v => /^[\dABCDEFGHJKLMNPRSTUVWXYZ\*]{17}$/.test(v) ||
                    'Должен содержать 17 знаков. Не использовать I (i), O (o), Q (q)',
                bodyNumber: v => /^[\dABCDEFGHJKLMNPQRSTUVWXYZ-]{6,24}$/.test(v) || 'Неверный формат',
                chassisNumber: v => /^[\dABCDEFGHJKLMNPQRSTUVWXYZ-]{6,24}$/.test(v) || 'Неверный формат',
                license: v => /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) || 'Неверный формат',
                yearIssue: v => this.isYearValidRule(v),
                // это правило будет меняться в зависимости от категории и цели использования ТС
                numberRule: v => /^[А-ЯЁ\d]{4,}$/.test(v) || 'Неверный формат',
                hp: v => (v > 0 && !isNaN(v)) || 'Введите положительное число',
                kw: v => (v > 0 && !isNaN(v)) || 'Введите положительное число',
            },

            loader: null,
            loading: false,

            hpInput: null,
            kwInput: null,
        }
    },

    computed: {
        allowedYears: function () {
            if (!this.modifications) {
                return [];
            }
            let years = [];
            this.allowedModifications.forEach(function (item) {
                years = years.concat(item.years);
            });
            return years.filter(this.onlyUnique).sort();
        },

        allowedEnginePowers: function () {
            if (!this.modifications) {
                return [];
            }
            let powers = [];
            this.allowedModifications.forEach(function (item) {
                powers.push(item.power);
            });
            return powers.filter(this.onlyUnique).sort();
        },

        allowedMaxWeights: function () {
            if (!this.modifications) {
                return [];
            }
            let weights = [];
            this.allowedModifications.forEach(function (item) {
                weights.push(item.maxWeight);
            });
            return weights.filter(this.onlyUnique).sort();
        },

        allowedSeats: function () {
            if (!this.modifications) {
                return [];
            }
            let seats = [];
            this.allowedModifications.forEach(function (item) {
                seats.push(item.seats);
            })
            return seats.filter(this.onlyUnique).sort();
        },

        allowedModifications: function () {
            if (!this.modifications) {
                return [];
            }
            let names = [];
            const value = this.value;
            this.modifications.forEach(function (item) {
                if (value.category === item.category &&
                    ((value.yearIssue && item.years.indexOf(value.yearIssue) !== -1) || !value.yearIssue) &&
                    ((value.power && value.category !== 'C' && value.category !== 'D' && item.power == value.power) ||
                        !value.power || value.category === 'C' || value.category === 'D') &&
                    ((value.maxMass && value.category === 'C' && item.maxWeight == value.maxMass) ||
                        !value.maxMass || value.category !== 'C') &&
                    ((value.seats !== null && value.seats !== undefined && value.category === 'D' && item.seats == value.seats) ||
                        !value.seats || value.category !== 'D')
                ) {
                    names.push({
                        'name': item.name,
                        'code': item.carCode,
                        'power': item.power,
                        'maxWeight': item.maxWeight,
                        'seats': item.seats,
                        'years': item.years
                    });
                }
            });
            return names.sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
            });
        },

        setModification() {
            return {
                'category': this.value.category,
                'power': this.value.power,
                'year': this.value.year,
                'maxMass': this.value.maxMass,
                'seats': this.value.seats,
                'allowedMods': this.allowedModifications,
                'time': Date.now()
            };
        },

        isDefaultValue() {
            return !_.isEqualWith(this.value, this.defaultValue, (a, b) => {
                if ((_.isNull(a) || a === '') && (_.isNull(b) || b === '')) return true;
            });
        },

        showWrittenMake() {
            const mark = this.value.mark ? this.value.mark.toLowerCase() : '';
            return mark.indexOf('друго') !== -1 || mark.indexOf('друга') !== -1;
        },

        showWrittenModel() {
            const model = this.value.model ? this.value.model.toLowerCase() : '';
            return model.indexOf('друго') !== -1 || model.indexOf('друга') !== -1;
        },

        categoryAndUseType() {
            return this.useType + this.value.category;
        }
    },

    created: function () {
        if (this.short && this.value.mark) {
            this.showMark = true;
        }
        const url = this.isEgarant ? '/dict/eg-marks' : '/dict/marks';

        if (this.b2b) {
            axios.get(url)
                .then(response => {
                    this.transportMarks = response.data;
                });
        }


        if (this.value.vin) {
            this.TSLoaded = true;
        }

        this.prevVinValue = this.value.vin;

        if (this.isDraft) {
            this.$nextTick(function () {
                this.loadInfoByLicensePlate();
            });
        }
    },

    mounted: function () {
        Object.entries(this.$refs).forEach(function (val) {
            val[1].blur = function (e) {
                setTimeout(() => val[1].blur(e), 0);
            };
        });
    },

    watch: {
        loader() {
            this[this.loader] = !this[this.loader]
        },

        setModification() {
            if (this.allowedModifications.length &&
                ((this.value.maxMass && this.value.category === 'C') ||
                    (this.value.seats !== null && this.value.seats !== undefined && this.value.category === 'D') ||
                    (this.value.power && this.value.category !== 'C' && this.value.category !== 'D'))) {
                this.value.carCode = this.allowedModifications[0].code;
            } else {
                this.value.carCode = null;
            }
        },

        categoryAndUseType() {
            let func = v => /^[А-ЯЁ\d]{4,}$/.test(v) || 'Неверный формат';

            if (!this.value.category) {
                this.rules.numberRule = func;
                return;
            }

            if (this.value.category === 'A') {
                func = v => /^[\d]{4}[АВЕКМНОРСТУХ]{2}[\d]{2,3}$/.test(v) || // 1234 АА 123; 1234 АА 12;
                    /^[АВЕКМНОРСТУХ]{2}[\d]{4}[\d]{2,3}$/.test(v) || // АА 1234 123; АА 1234 12;
                    /^[АВЕКМНОРСТУХ]{2}[\d]{2}[АВЕКМНОРСТУХ]{2}[\d]{2,3}$/.test(v) || // АА 12 АА 123; АА 12 АА 12;
                    'Неверный формат для категории A';
            } else if (this.value.category === 'T') {
                func = v => /^[\d]{4}[А-ЯЁ]{2}[\d]{2,3}$/.test(v) || // 1234 АА 123; 1234 АА 12;
                    /^[А-ЯЁ]{2}[\d]{4}[\d]{2,3}$/.test(v) || // АА 1234 123; АА 1234 12;
                    /^[А-ЯЁ]{2}[\d]{2}[А-ЯЁ]{2}[\d]{2,3}$/.test(v) || // АА 12 АА 123; АА 12 АА 12;
                    'Неверный формат для категории T';
            } else if (['B', 'C', 'D'].includes(this.value.category)) {
                if ((this.useType === Vue.GetpolisConstants.USE_TYPES.TAXI && this.value.category === 'B') ||
                    (this.useType === Vue.GetpolisConstants.USE_TYPES.REGULAR_TRANSPORTATION && this.value.category === 'D')) {
                    func = v => /^[АВЕКМНОРСТУХ][\d]{3}[АВЕКМНОРСТУХ]{2}[\d]{2,3}$/.test(v) || // А 123 АА 123, А 123 АА 12
                        /^[АВЕКМНОРСТУХ]{2}[\d]{3}[\d]{2,3}$/.test(v) || // АА 123 123; АА 123 12;
                        'Неверный формат для категории ' + this.value.category;
                }
                func = v => /^[АВЕКМНОРСТУХ][\d]{3}[АВЕКМНОРСТУХ]{2}[\d]{2,3}$/.test(v) || // А 123 АА 123, А 123 АА 12
                    'Неверный формат для категории ' + this.value.category;
            }
            this.rules.numberRule = func;
        },

        'value.carDoc.type': {
            handler() {
                if (this.value.carDoc.type === 'srts') {
                    // при указании документа СТС ввод госномера обязателен
                    this.value.noLicensePlate = false;
                }
            }
        },

        'value.power': {
            handler(newVal) {
                if (newVal && !isNaN(newVal)) {
                    this.hpInput = newVal
                    this.kwInput = (newVal / 1.36).toFixed(1)
                } else {
                    this.hpInput = null
                    this.kwInput = null
                }
            },
            immediate: true
        },

        showWrittenMake(newVal) {
            if (!newVal) {
                this.value.writtenMark = null;
            }
        },

        showWrittenModel(newVal) {
            if (!newVal) {
                this.value.writtenModel = null;
            }
        },
    },

    methods: {
        modelSearch(model) {
            if (model && model !== this.value.model) {
                this.value.model = '';
                const that = this;
                setTimeout(() => {
                    that.modelSearchSync = model;
                }, 0);
            }
            this.loadModel(this.value.mark, model);
        },

        markSearch(mark) {
            if (mark && mark !== this.value.mark) {
                this.value.mark = '';
                this.value.model = '';
                const that = this;
                setTimeout(() => {
                    that.markSearchSync = mark;
                }, 0);
            }
            this.loadModels(mark);
        },

        loadModels(mark) {
            if (!mark) {
                return;
            }

            mark = mark.replace(/\//g, "@@@");
            const url = this.isEgarant ? '/dict/eg-models/' : '/dict/models/';

            if (this.b2b) {
                axios.get(url + mark).then(response => {
                    this.transportModels = response.data;
                    if (!!this.value.model) {
                        const matchedModel = this.transportModels.find(
                            m => m.toLowerCase() === this.value.model.toLowerCase()
                        );
                        if (matchedModel) {
                            this.value.model = matchedModel;
                        } else {
                            this.$nextTick(function () {
                                this.value.model = null;
                            });
                        }
                    }
                }).catch(error => {
                    console.log('Load models error mark = ' + mark + ' :', error);
                });
            }
        },

        loadModelsAndSetModel(mark, modelDefault) {
            if (!mark || !modelDefault) {
                return;
            }

            const encodedMark = mark.replace(/\//g, "@@@");
            const url = this.isEgarant ? '/dict/eg-models/' : '/dict/models/';

            axios.get(url + encodedMark).then(response => {
                this.transportModels = response.data;
                const matchedModel = this.transportModels.find(
                    m => m.toLowerCase() === modelDefault.toLowerCase()
                );
                const prevModel = this.value.model;
                this.value.model = matchedModel || modelDefault;
                if (prevModel !== this.value.model) {
                    this.loadModel(mark, this.value.model);
                }
            }).catch(error => {
                console.log('Load models for model-set error mark = ' + mark + ' :', error);
            });
        },

        loadModel(mark, model) {
            if (!mark || !model) {
                return;
            }
            mark = mark.replace(/\//g, "@@@");
            model = model.replace(/\//g, "@@@");
            const url = this.isEgarant ? '/dict/eg-model-info/' : '/dict/model-info/';
            axios.get(url + mark + '/' + model).then(response => {
                if (response.data) {
                    this.modelCategories = response.data.categories;
                    if (response.data.categories.length === 0) {
                        this.value.category = null;
                        this.modifications = [];
                        return;
                    } else if (response.data.categories.indexOf(this.value.category) === -1) {
                        this.value.category = response.data.categories[0];
                    }
                    this.loadModifications(mark, model, this.value.category);
                } else {
                    console.log(response);
                }
            }).catch(error => {
                console.log('Load model info mark = ' + mark + ', model = ' + model + ' error: ', error);
            });
        },

        loadModifications(mark, model, category) {
            if (!mark || !model || !category) {
                return;
            }
            mark = mark.replace(/\//g, "@@@");
            model = model.replace(/\//g, "@@@");
            const url = this.isEgarant ? '/dict/eg-model-info-category/' : '/dict/model-info-category/';
            axios.get(url + mark + '/' + model + '/' + category).then(response => {
                if (response.data) {
                    this.modifications = response.data.modifications;
                    //this.checkAvtokodAllowedValues();
                } else {
                    console.log(response);
                }
            }).catch(error => {
                console.log('Load modifications mark = ' +
                    mark + ', model = ' + model +
                    ', category = ' + category + ' error: ', error);
            });
        },

        vinOtoZeroAndUpperCase: function (value) {
            if (!value) return null;
            if (value.includes('*')) return;
            this.value.vin = value.toString().toUpperCase().replace(/O/g, '0');
            return value;
        },

        stringToUpper: function (value) {
            if (!value) return null;
            return value.toString().toUpperCase();
        },

        isYearValidRule: function (year) {
            if (this.isInvalidYear(year)) {
                return 'Неверно указан год выпуска';
            }
            return false;
        },

        isInvalidYear: function (year) {
            return year < 1930 || year > this.dateToday.slice(0, 4);
        },

        nullNumberValues: function () {
            this.value.vin = null;
            this.value.bodyNumber = null;
            this.value.chassisNumber = null;
        },

        onlyUnique: function (value, index, self) {
            return self.indexOf(value) === index;
        },

        modificationChanged: function (value) {
            if (!value) {
                return;
            }

            const mods = this.allowedModifications;
            for (let i = 0; i < mods.length; i++) {
                if (mods[i].code === value) {
                    this.value.power = mods[i].power;
                    this.value.maxMass = mods[i].maxWeight;
                    this.value.seats = mods[i].seats;
                    break;
                }
            }
        },

        loadInfoByLicensePlate() {
            if (this.value.noLicensePlate || this.loadingLicensePlateInfo) {
                return;
            }
            if (!(/^[А-ЯЁ\d]{4,}$/.test(this.value.licensePlate))) {
                PNotify.error('Неправильный формат номера');
                return;
            }

            this.loadingLicensePlateInfo = true;

            let that = this;
            axios.get('/info/number-info-b2b/' + this.value.licensePlate).then(function (result) {
                if (result.data.response && result.data.status === 'ok') {
                    console.log(result.data.response);
                    const info = result.data.response;
                    that.value.idType = 'vin';
                    if (info.vin) {
                        that.$nextTick(function () {
                            that.value.bodyNumber = '';
                            that.value.vin = info.vin;
                        });
                    } else if (info.body) {
                        that.value.idType = 'bodyNumber';
                        that.$nextTick(function () {
                            that.value.vin = '';
                            that.value.bodyNumber = info.body;
                        });
                    } else {
                        that.$nextTick(function () {
                            that.value.vin = that.value.bodyNumber = '';
                        });
                    }
                    that.checkAvtokodAllowedPower = info.power;
                    that.value.yearIssue = info.year;
                    that.value.carDoc.type = info.stsType;
                    that.value.carDoc.seriesNumber = info.sts;
                    that.value.carDoc.date = info.stsDate;
                    that.value.power = info.power;
                    that.value.powerAvtocod = info.power;

                    that.$nextTick(function () {
                        this.loadGibddInfo();
                    });

                    if (info.brandDefault) {
                        const matchedMark = that.transportMarks.find(
                            m => m.toLowerCase() === info.brandDefault.toLowerCase()
                        );
                        that.value.mark = matchedMark || info.brandDefault;
                    }
                    if (info.modelDefault) {
                        that.checkAvtokodAllowed = true;
                        that.loadModelsAndSetModel(that.value.mark, info.modelDefault);
                    } else {
                        that.value.power = info.power;
                        that.value.powerAvtocod = info.power;
                    }

                    that.$nextTick(function () {
                        that.numberInfoRequested = true;
                        that.$emit('numberInfoLoaded');
                    });
                    if (info.age && info.age < 4) {

                    }
                } else {
                    console.log('Number info response:', result);
                    PNotify.error('Не удалось получить данные по номеру');
                }
            }).catch(function (error) {
                console.log('Error: ', error);
                PNotify.error('Не удалось получить данные по номеру');
            }).finally(() => this.loadingLicensePlateInfo = false);
        },

        loadGibddInfo() {
            if (!this.value.vin) {
                return;
            }

            this.loadingGibddData = true;

            axios.get('/info/gibdd?vin=' + this.value.vin)
                .then((result) => {
                    let responseFromGibddRequest = JSON.parse(result.data);

                    if (responseFromGibddRequest.response && responseFromGibddRequest.status === 'ok') {
                        const info = responseFromGibddRequest.response;

                        if (!this.value.gibddData) {
                            this.value.gibddData = {};
                        }

                        if (this.isEgarant && info.ptsNum != null && info.ptsNum !== '') {
                            this.value.carDoc.type = info.ptsType;
                            this.value.carDoc.seriesNumber = info.ptsNum;
                        }
                        if (info.powerHp != null && info.powerHp !== '') {
                            this.value.power = info.powerHp;
                            this.value.powerAvtocod = info.powerHp;
                            this.value.gibddData.powerHp = info.powerHp;
                        }
                        if (info.model != null && info.model !== '') {
                            this.value.gibddData.model = info.model;
                        }
                        if (info.type != null && info.type !== '') {
                            this.value.gibddData.category = info.type;
                        }
                        if (info.vin != null && info.vin !== '') {
                            this.value.gibddData.vin = info.vin;
                        }
                    } else {
                        console.error('Не удалось получить данные ГИБДД. Number info response:', result);
                    }
                })
                .catch((error) => {
                    console.error('Не удалось получить данные ГИБДД. Error: ', error);
                })
                .finally(() => {
                    this.loadingGibddData = false;
                });
        },

        checkAvtokodAllowedValues() {
            if (this.checkAvtokodAllowed) {
                this.checkAvtokodAllowed = false;
                this.$nextTick(() => {
                    /*if (this.checkAvtokodAllowedPower) {
                        if (this.allowedEnginePowers.indexOf(this.checkAvtokodAllowedPower) === -1) {
                            this.value.power = this.checkAvtokodAllowedPower;
                        }
                    }*/
                    this.checkAvtokodAllowedPower = null;
                });
            }
        },

        onVinNumberBlur() {
            // получить данные полиса при условии, что:
            // убран фокус с поля VIN,
            // не запрашивались данные по госномеру,
            // VIN состоит из 17 знаков
            clearTimeout(this.vinBlurTimer);
            if (this.value.vin && this.value.vin.length === 17) {
                this.vinBlurTimer = setTimeout(() => {
                    if (this.value.vin !== this.prevVinValue) {
                        this.loadGibddInfo();

                        if (!this.numberInfoRequested) {
                            this.numberInfoRequested = true;
                            this.$emit('numberInfoLoaded');
                        }
                    }

                    this.prevVinValue = this.value.vin;
                }, 2 * 1000);
            }
        },

        syncFromHp() {
            let num = this.normalize(this.hpInput)
            if (num !== null) {
                const hp = Math.ceil(num)
                this.value.power = hp
                this.hpInput = hp
                this.kwInput = (hp / 1.36).toFixed(1)
            } else {
                this.value.power = null
                this.hpInput = null
                this.kwInput = null
            }
        },
        syncFromKw() {
            let num = this.normalize(this.kwInput)
            if (num !== null) {
                const hp = Math.ceil(num * 1.36)
                this.value.power = hp
                this.hpInput = hp
                this.kwInput = (hp / 1.36).toFixed(1)
            } else {
                this.value.power = null
                this.hpInput = null
                this.kwInput = null
            }
        },
        onlyNumberAndDot(e) {
            const char = String.fromCharCode(e.keyCode || e.which)
            if (!/[0-9.,]/.test(char)) {
                e.preventDefault()
            }
        },
        replaceComma(inputValue) {
            if (typeof inputValue === 'string') {
                inputValue = inputValue.replace(',', '.')
            }
        },
        normalize(val) {
            if (!val) return null
            val = String(val).replace(',', '.')
            let num = parseFloat(val)
            return isNaN(num) || num <= 0 ? null : num
        },
    },
}
</script>

<style scoped>

.modification-select >>> .v-select__selection--comma {
    margin-top: 0 !important;
    font-size: 14px !important;
}

a.policy {
    color: #00ba57;
}

a.policy-disabled {
    color: #858585;
}

.checkbox-plate >>> .v-input__control {
    height: 25px;
}

.hide-vin-field {
    display: none;
}

.pts-help-text {
    display: flex;
    align-items: center;
}
</style>
<style>
.to-upper-case input {
    text-transform: uppercase;
}

.flex-end {
    align-self: flex-end;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input {
    -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// resources/js/components/fields/Transport.vue